<template>
  <div>
    <HMModalHeader
      :title="$t('PRODUCTS.LINK.MODIFY_ORDER')"
      @close="$emit('close')"
    />
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="onConfirm">
        <div class="form-group">
          <label class="mt-3">
            {{ $t('CUSTOMERS.LABEL.MODIFY_PAID_AMOUNT') }}
          </label>
          <HMTextInput
            type="number"
            v-model="localOrder.amount_paid"
            rules="required|min_value:0"
            name="Paid amount"
            step="any"
          >
            <template slot="prepend">{{ order.currency || 'USD' }}</template>
          </HMTextInput>
        </div>
        <HMModalFooter
          class="mt-3"
          :disabled="invalid || !localOrder.amount_paid || isUpdating"
          :submitButton="$t('GENERAL.BUTTON.UPDATE')"
          @close="$emit('close')"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { ValidationObserver } from 'vee-validate';
import HMTextInput from '@/web/components/common/HMTextInput.vue';
import _ from 'lodash';

export default Vue.extend({
  name: 'ModifyOrderModal',
  components: { HMTextInput, ValidationObserver },
  props: {
    order: {
      type: Object,
    },
  },
  data() {
    return {
      localOrder: null,
      isUpdating: false,
    };
  },
  methods: {
    async onConfirm() {
      if (this.localOrder) {
        this.isUpdating = true;
        try {
          await this.$store.dispatch('sale/updateOrder', this.localOrder);
          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$t('CUSTOMERS.NOTIFICATIONS.ORDER_UPDATE_SUCCESS'),
          });
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to update the order',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        } finally {
          this.isUpdating = false;
        }
      }
      this.$emit('close');
    },
  },
  mounted() {
    this.localOrder = _.cloneDeep(this.order);
  },
});
</script>

<style lang="scss" scoped></style>
